module.exports = __webpack_public_path__ + "static/media/Courier New-01.fbdf9676.svg";